import { ICON_TYPES } from '../constants';

export const BarbaqueIcon = (): JSX.Element => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M21 6.125V5.25H0V6.125C0.00114298 7.99244 0.500014 9.82583 1.44525 11.4364C2.39048 13.0469 3.7479 14.3764 5.37775 15.288L2.52175 21H4.47825L6.97113 16.0125C7.8268 16.3195 8.71902 16.5131 9.625 16.5882V21H11.375V16.5882C12.2809 16.5137 13.1731 16.3207 14.0289 16.0142L16.5217 21H18.4783L15.6222 15.288C17.2521 14.3764 18.6095 13.0469 19.5548 11.4364C20.5 9.82583 20.9989 7.99244 21 6.125ZM10.5 14.875C8.33155 14.8725 6.24108 14.0659 4.63291 12.6113C3.02473 11.1566 2.01313 9.15732 1.79375 7H19.2063C18.9869 9.15732 17.9753 11.1566 16.3671 12.6113C14.7589 14.0659 12.6684 14.8725 10.5 14.875ZM11.375 3.5H9.625V0H11.375V3.5ZM14.875 3.5H13.125V0H14.875V3.5ZM7.875 3.5H6.125V0H7.875V3.5Z"
          fill="#43494F"
        />
      </g>
    </svg>
  );
};

BarbaqueIcon.iconType = ICON_TYPES.BARBAQUE;
